import { gql } from "@apollo/client";

export const PUBLIC_DATA_COMPLETION_QUERY = gql`
  query publicDataCompletion($quoteId: Int!) {
    publicDataCompletion(quoteId: $quoteId) {
      quoteId
      quoteStatusId
      requiredDocuments {
        quoteId
        id
        guarantorId
        requiredDocTypeId
        requiredDocFileName
        requiredDocName
        requiredDocContentType
        targetAreaCode
        caption
        isVisible
        isMandatory
        files {
          sharePointUID
          fileName
        }
      }
      supportContact {
        boSupportName
        boSupportPhone
        boSupportEmail
        boSupportPicture
      }
    }
  }
`;

export const PUBLIC_CONTRACTUAL_DOCUMENTS_QUERY = gql`
  query publicContractualDocuments($quoteId: Int!) {
    publicContractualDocuments(quoteId: $quoteId) {
      quoteId
      quoteStatusId
      leasingContracts {
        documentId
        siteId
        clientId
        documentDate
        documentStateCode
        documentStateName
        documentNumber
        allowToggle
        allowUpload
        allowDownload
        allowDownloadTemplate
        requiredDocuments {
          quoteId
          id
          requiredDocTypeId
          requiredDocFileName
          requiredDocName
          requiredDocContentType
          targetAreaCode
          caption
          isVisible
          isMandatory
          documentTemplateId
          templateContentType
          guarantorId
          guarantorName
          files {
            sharePointUID
            fileName
          }
        }
      }
    }
  }
`;

export const PUBLIC_USER_DATA_QUERY = gql`
  query publicUserData {
    publicUserData {
      email
      lastName
      firstName
      mobilePhone
    }
  }
`;
